import React, { CSSProperties, forwardRef } from 'react';

import clsx from 'clsx';

import { flex } from './Flex.css';

export interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  justify?: 'start' | 'end' | 'center' | 'between' | 'around' | 'evenly';
  align?: 'start' | 'end' | 'center' | 'baseline' | 'stretch';
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  gap?: number;
  children?: React.ReactNode;
  style?: CSSProperties;
}

export const Flex = forwardRef<HTMLDivElement, FlexProps>(
  ({ direction, justify, align, wrap, gap, children, style, className, ...props }, ref) => {
    const combinedStyle: CSSProperties = {
      ...style,
      ...(gap !== undefined && { gap: `${gap}px` }),
    };

    return (
      <div
        ref={ref}
        className={clsx(flex({ direction, justify, align, wrap }), className)}
        style={combinedStyle}
        {...props}
      >
        {children}
      </div>
    );
  },
);

Flex.displayName = 'Flex';
